module.exports = __webpack_public_path__ + "static/media/divisional_integrity.77102b9d.jpg";